import script from "./EmberCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmberCanvas.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__